import React from "react";
import { Typography, Box, Select, MenuItem } from "@mui/material";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import CardMonthYearPicker from "./CardMonthPicker";
import { fixedTons, formatNumberCommaSeparated } from "../../utils/common";
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

Chart.register(ArcElement, Tooltip, Legend);

const FilterCard = ({
  item,
  selectedValue,
  handleSelect,
  setSelectedMonth,
  setSelectedYear,
  selectedMonth,
  selectedYear,
  singleRow,
  width,
}) => {
  const normalizedWidth =
    typeof width === "string" ? width.trim() : "";
  const resolvedCardWidth =
    normalizedWidth.endsWith("%") && normalizedWidth !== ""
      ? normalizedWidth
      : "32%";

  const chartData =
    item.key === "ownership" || item?.key === "employeeCommute"
      ? item.chartData
      : [];
  const backgroundColors =
    item.key === "ownership" || item?.key === "employeeCommute"
      ? item.backgroundColors
      : [];

  const data = {
    datasets: [
      {
        data: formatNumberCommaSeparated(chartData),
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  return (
    <Box
      sx={{
        backgroundColor: "#FCFCFC",
        borderRadius: "12px",
        padding: "1.25rem",
        boxShadow: "rgba(0, 0, 0, 0.15)",
        ...(singleRow
          ? {
              flex: "1 1 0",
              minWidth: { xs: "200px", sm: "220px" },
              width: "auto",
              maxWidth: "100%",
            }
          : {
              width: resolvedCardWidth,
            }),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: item?.height || "10rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "0.3rem",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "16px",
            fontWeight: "600",
            color: "#000000",
          }}
        >
          {item?.title}
        </Typography>

        {item?.filter === "option" && (
          <Select
            size="small"
            displayEmpty
            value={
              selectedValue !== undefined && selectedValue !== ""
                ? selectedValue
                : item.defaultValue || item.filterValues?.[0] || ""
            }
            onChange={(e) =>
              handleSelect(item.key, e.target.value, item.filter)
            }
            sx={{
              fontSize: "14px",
              height: "30px",
              minWidth: "10rem",
              width: "10rem",
              textOverflow: "ellipsis",
            }}
          >
            <MenuItem
              value=""
              disabled
              sx={{
                fontSize: "14px",
                color: "#aaa", // lighter to look like a placeholder
              }}
            >
              Select
            </MenuItem>

            {item?.filterValues?.map((option, idx) => (
              <MenuItem
                key={idx}
                value={option}
                sx={{
                  fontSize: "14px",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  maxWidth: "300px",
                }}
              >
                {option}
              </MenuItem>
            ))}
          </Select>
        )}

        {item?.filter === "date" && (
          <Box sx={{ paddingBottom: "1rem" }}>
            <CardMonthYearPicker
              {...{
                setSelectedMonth,
                setSelectedYear,
                selectedMonth,
                selectedYear,
                defaultMonth: currentMonth + 1,
                defaultYear: currentYear,
                gap: "0.3rem",
              }}
            />
          </Box>
        )}
      </Box>

      {Array.isArray(item?.description) ? (
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: "500",
            color: "#555",
            width: "100%",
            marginTop: "1rem",
          }}
        >
          {item?.description?.length > 0
            ? item?.description.join(" | ")
            : "N/A"}
        </Typography>
      ) : (
        <Typography
          style={{
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: "500",
            color: "#555",
          }}
        >
          {typeof item?.description === "number"
            ? formatNumberCommaSeparated(fixedTons(item?.description ?? 0)) +
              (item?.unit === undefined ? "" : " " + item?.unit)
            : item?.description}
        </Typography>
      )}

      {item.key === "ownership" && (
        // <>
        // <Box sx={{ display: "flex", gap: "15px", marginTop: "1rem" }}>
        //     <Box sx={{ display: "flex", alignItems: "center" }}>
        //       <span style={{ backgroundColor: '#FF6384', width: '10px', height: '10px', borderRadius: '50%', display: 'inline-block', marginRight: '5px' }}></span>
        //       <Typography sx={{ fontFamily: "Inter", fontSize: "14px", fontWeight: "500", color: "#555" }}>
        //         Company Owned
        //       </Typography>
        //     </Box>

        //     <Box sx={{ display: 'flex', alignItems: 'center' }}>
        //       <span style={{ backgroundColor: '#36A2EB', width: '10px', height: '10px', borderRadius: '50%', display: 'inline-block', marginRight: '5px' }}></span>
        //       <Typography sx={{ fontFamily: "Inter", fontSize: "14px", fontWeight: "500", color: "#555" }}>
        //         Third Party Vendors
        //       </Typography>
        //     </Box>
        //   </Box>
        //   <Pie data={data} options={{ responsive: true, maintainAspectRatio: true }} />
        // </>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            height: "12rem",
            marginTop: "0rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "60%",
              gap:"1rem"
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span
                style={{
                  backgroundColor: "#FF6384",
                  width: "11px",
                  height: "10px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "5px",
                }}
              ></span>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#555",
                }}
              >
                Company Owned
              </Typography>
            </Box>

            <Box sx={{ display: "flex",  gap: "5px" }}>
              <span
                style={{
                  backgroundColor: "#36A2EB",
                  width: "11px",
                  height: "10px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "5px",
                }}
              ></span>
              <Box sx={{mt:"-0.3rem"}}>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#555",
                }}
              >
                Third Party Vendors
              </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{ width: "30%",height:"98%" }}>
            <Pie
              data={data}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </Box>
        </Box>
      )}

      {item.key === "employeeCommute" && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            height: "12rem",
            marginTop: "-2rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "50%",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span
                style={{
                  backgroundColor: "#FF6384",
                  width: "12px",
                  height: "11px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "5px",
                }}
              ></span>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#555",
                }}
              >
                Company Owned
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span
                style={{
                  backgroundColor: "#36A2EB",
                  width: "11px",
                  height: "11px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "5px",
                }}
              ></span>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#555",
                }}
              >
                Personal
              </Typography>
            </Box>
          </Box>

          <Box sx={{ width: "30%" }}>
            <Pie
              data={data}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </Box>
        </Box>
      )}

      {item.multiple && (
        <Box sx={{ display: "flex", gap: "15px" }}>
          <Box>{item.multipleValues[0]}</Box>
          <Box>{item.multipleValues[1]}</Box>
        </Box>
      )}
    </Box>
  );
};

export default FilterCard;
